import React from "react";

import ScraperContext, { ScraperContextState } from "./ScraperContext";

// Wraps around BlueprintEditor to be able to pull global state anywhere in tree via useContext
const useScraperContext = (): ScraperContextState => React.useContext(ScraperContext);

export default useScraperContext;
